import {createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';


const cryptoApiHeaders={
    'x-rapidapi-host': 'coinranking1.p.rapidapi.com',
    'x-rapidapi-key': 'a0f56d12c9msh65e68ee0f69200bp146854jsn65db25efcdd5'
}

const baseUrl='https://coinranking1.p.rapidapi.com';
const createRequest =(url)=>({url, headers:cryptoApiHeaders});

export const cryptoApi= createApi({
    reducerPath:'cryptoApi',
    baseQuery:fetchBaseQuery({baseUrl}),
    endpoints: (builder)=>({
        getCryptos:builder.query({
            query: (count)=> createRequest(`/coins?limit=${count}`)
        }),
        getCryptoDetails: builder.query({
            query: (coinId) => createRequest(`/coin/${coinId}`)
        }),
        getCryptoHistory: builder.query({
            query: (coinId) => createRequest(`coin/${coinId}/history`),
        }),
        getExchanges: builder.query({
            query: () => createRequest('/exchanges'),
          }),
    })

});

export const {
    useGetCryptosQuery,
    useGetCryptoDetailsQuery,
    useGetCryptoHistoryQuery,
    useGetExchangesQuery
}=cryptoApi;